var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMehanikaBijela(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    fill: "white",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.19084 15.56502c.25225 4.75929 7.09718 4.2255 6.69706-.52987.00006.00007-6.69706.00007-6.69706.00007z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.80487 15.56502c.25703 4.75759 7.09306 4.22342 6.69706-.52987.00006.00007-6.69706.00007-6.69706.00007z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.92577 18.75365c2.06808.68904 4.3836-.95798 4.34813-3.18866.00003.00004.00003-.52976.00003-.52976h-6.69712c-.16508 1.64766.77816 3.24803 2.34896 3.71843z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 9.036,
    rx: 1.999,
    width: 51.288,
    x: 4.588,
    y: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.42201 49.63029c-.65969-.46977-1.42938-.79964-2.26898-.9396v-27.87793c-.31987.05997-.64974.08993-.99957.08993-.34989 0-.6797-.02996-.99957-.08993v27.87793c-2.66889.45982-4.69799 2.78884-4.69799 5.58762-.09518 4.52702 5.35666 7.33406 8.96617 4.65783-2.09497-2.65283-2.10094-6.66133-.00006-9.30585z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.81798 49.63029c-.66969-.46977-1.43938-.79964-2.27899-.9396v-27.87793c-.63972.1199-1.35948.11992-1.99914 0v27.87793c-1.52937.2599-2.84881 1.13952-3.69842 2.36897-3.53084 5.17843 2.79095 11.48373 7.96664 7.8765-2.08098-2.64771-2.09113-6.66544.0099-9.30588z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m35.9249 48.69069v-27.87793c-.62976.11977-1.36934.12004-1.99914 0v27.87793c-1.52931.2599-2.83874 1.13952-3.68841 2.36897-2.59984 3.55645.18843 9.04008 4.68812 8.91608 6.92914-.15067 7.76049-9.97192.99943-11.28506z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m45.55076 18.66366c1.43223-.53956 2.26269-2.06813 2.10901-3.62847.00007.00002-6.69699.00002-6.69699.00002v.5298c-.04914 2.33078 2.49863 3.99463 4.58799 3.09864z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m59.22486 51.56945c-.71966-2.69879-3.28856-4.42808-5.9774-4.19814l-7.1769-26.76849c-.58963.21812-1.30336.33503-1.98913.28986 0 0 7.22687 26.99836 7.22687 26.99836-2.44896 1.14953-3.79835 3.91829-3.07869 6.62715 2.18734 7.20743 12.70328 4.40158 10.99526-2.94874z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMehanikaBijela);
export default __webpack_public_path__ + "static/media/icon-mehanika-bijela.2f4a1fd94633ccc5c4d3a072e2512441.svg";
export { ForwardRef as ReactComponent };